import { ROUTES } from 'config';
import { ActionsMenu } from 'melp-design/components';
import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useMe } from 'state/Administrators';
import { useConfirm } from 'store/confirm';
import { useRemoveNewsCategory } from 'store/news';
import { usePredefinedToasts } from 'utils/Toast';

interface Props {
  id: string;
  name: string;
  type?: ComponentProps<typeof ActionsMenu>['type'];
}

export const CategoryActions: FC<Props> = ({ id, name, type }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { hasEditPermission } = useMe();
  const predefinedToasts = usePredefinedToasts();
  const { confirmation } = useConfirm();

  const { mutate: removeCategory, isLoading: isRemoving } =
    useRemoveNewsCategory();

  return (
    <ActionsMenu
      type={type}
      items={[
        {
          label: t('actions.delete'),
          onClick: async () => {
            const { confirmed } = await confirmation(
              t('common.areYouSureToDelete', {
                title: name,
              }),
              undefined,
              'danger',
            );

            if (confirmed) {
              removeCategory(
                { categoryId: id },
                {
                  onSuccess: () => {
                    predefinedToasts.success.deleted();
                    history.push(`${ROUTES.news.list}?tab=categories`);
                  },
                },
              );
            }
          },
          color: 'error',
          disabled: isRemoving || !hasEditPermission(['news']),
        },
      ]}
    />
  );
};
